"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const effects_1 = require("redux-saga/effects");
const constants_1 = __importDefault(require("../../constants/constants"));
const apis_1 = require("../../networking/apis");
const Auth_1 = __importDefault(require("../../networking/apis/Auth"));
const User_1 = __importDefault(require("../../networking/apis/User"));
const AsyncStorage_1 = __importDefault(require("../../utils/AsyncStorage"));
const slice_1 = require("../login/slice");
const actions_1 = require("../loginFirebase/actions");
const slice_2 = __importDefault(require("./slice"));
const rootNavigation_1 = require("../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../navigators/Routes"));
function* logout() {
    try {
        const messagingToken = yield AsyncStorage_1.default.get(constants_1.default.FIREBASE_MESSAGING_TOKEN);
        yield AsyncStorage_1.default.remove(constants_1.default.ACCESS_TOKEN_LOCAL);
        yield AsyncStorage_1.default.remove(constants_1.default.REFRESH_TOKEN_LOCAL);
        yield AsyncStorage_1.default.remove(constants_1.default.FIREBASE_TOKEN);
        yield (0, effects_1.put)((0, slice_1.saveAccessTokenAction)(''));
        yield (0, effects_1.put)((0, slice_1.setProfileAction)(undefined));
        yield createAnonymousUser();
        if (!!messagingToken) {
            yield AsyncStorage_1.default.set(constants_1.default.FIREBASE_MESSAGING_TOKEN, '');
            yield apis_1.CommonApi.removeDeviceToken({
                platform: react_native_1.Platform.select({
                    android: 1,
                    ios: 2,
                    web: 3,
                    default: 3,
                }),
                token: messagingToken,
            });
        }
    }
    catch (err) {
        console.log(err);
    }
}
function* getUserProfile() {
    const response = yield User_1.default.retrieveUser();
    if (response.status == 200) {
        yield (0, effects_1.put)((0, slice_1.setProfileAction)(response.data.data));
        const isCompleteTutorial = yield AsyncStorage_1.default.get(constants_1.default.IS_COMPLETED_TUTORIAL);
        if (response?.data?.data?.registration_status != 0 &&
            !parseInt(isCompleteTutorial || '0')) {
            (0, rootNavigation_1.navigate)(Routes_1.default.AUTH_NAVIGATOR, {
                screen: Routes_1.default.TUTORIAL,
            });
        }
    }
}
function* createAnonymousUser() {
    const response = yield Auth_1.default.createAnonymousUser();
    if (response.status == 200) {
        const { token, refresh_token } = response.data.data;
        yield AsyncStorage_1.default.set(constants_1.default.ACCESS_TOKEN_LOCAL, token);
        yield AsyncStorage_1.default.set(constants_1.default.REFRESH_TOKEN_LOCAL, refresh_token);
        yield (0, effects_1.put)((0, slice_1.saveAccessTokenAction)(token));
        yield (0, effects_1.put)((0, actions_1.loginFirebaseStartAction)());
        yield getUserProfile();
    }
}
function* initAppData() {
    try {
        const accessToken = yield AsyncStorage_1.default.get(constants_1.default.ACCESS_TOKEN_LOCAL);
        if (!!accessToken && accessToken != 'undefined') {
            yield (0, effects_1.put)((0, slice_1.saveAccessTokenAction)(accessToken));
            yield (0, effects_1.put)((0, actions_1.loginFirebaseStartAction)());
            yield getUserProfile();
        }
        else {
            const response = yield Auth_1.default.createAnonymousUser();
            if (response.status == 200) {
                const { token, refresh_token } = response.data.data;
                yield AsyncStorage_1.default.set(constants_1.default.ACCESS_TOKEN_LOCAL, token);
                yield AsyncStorage_1.default.set(constants_1.default.REFRESH_TOKEN_LOCAL, refresh_token);
                yield (0, effects_1.put)((0, slice_1.saveAccessTokenAction)(token));
                yield (0, effects_1.put)((0, actions_1.loginFirebaseStartAction)());
                yield getUserProfile();
            }
        }
    }
    catch (err) {
        console.log(err);
    }
}
function* appSaga() {
    yield (0, effects_1.all)([
        (0, effects_1.takeLatest)(slice_2.default.actions.logout, logout),
        (0, effects_1.takeLatest)(slice_2.default.actions.initDataApp, initAppData),
    ]);
}
exports.default = appSaga;
